import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tpl-info',
  templateUrl: './tpl-info.component.html',
  styleUrls: ['./tpl-info.component.sass']
})
export class TplInfoComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() objColor: any;
  @Input() title_button: string;

  @Output() nextStep = new EventEmitter<string>();
  
  constructor() { }

  ngOnInit(): void {
  }

  setFormValue(){
    this.form.get('value').setValue('');
    this.nextStep.emit('');
  }

}
